import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getClaimFollowUpTypesSelect } from '../api/claimFollowUpType';

type QueryFnType = typeof getClaimFollowUpTypesSelect;

type UseClaimFollowUpTypesSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useClaimFollowUpTypesSelect = ({ config = {} }: UseClaimFollowUpTypesSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['claimFollowUpTypeSelect', i18n.language],
        queryFn: () => getClaimFollowUpTypesSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};